import type { ICompanyApplicationTenant } from "@models";

export const HOME_APPLICATION_FILTER_ALL = "all" as const;

/** Filter value from the tenants API `applicationName` field. */
export function getHomeApplicationFilterValue(
  tenant: ICompanyApplicationTenant,
): string {
  return tenant.applicationName.trim();
}

export function getUniqueHomeApplicationNames(
  tenants: ICompanyApplicationTenant[],
): string[] {
  return [
    ...new Set(
      tenants
        .map(getHomeApplicationFilterValue)
        .filter((applicationName) => applicationName.length > 0),
    ),
  ].sort((a, b) => a.localeCompare(b));
}
